import { IconProps } from '@/components/Icon';

export const IconClock = ({ width = 16, height = 16, color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg {...props} fill='none' height={height} viewBox='0 0 16 16' width={width} xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Zm7.75-4.25a.75.75 0 0 0-1.5 0V8c0 .414.336.75.75.75h3.25a.75.75 0 0 0 0-1.5h-2.5v-3.5Z'
        fill={color}
        fillRule='evenodd'
      />
    </svg>
  );
};
